import { axios } from "configs/axios";
import { QueryConfig } from "configs/react-query";
import { useQuery } from "react-query";

export const checkResetTokenValidity = (token: string) => {
  return axios.get(`/auth/resettokenvalidity?token=${token}`);
};

type UseCheckResetTokenValidityOptions = {
  config?: QueryConfig<typeof checkResetTokenValidity>;
  token: string;
};

export const useCheckResetTokenValidity = ({ config, token }: UseCheckResetTokenValidityOptions) => {
  return useQuery({
    ...config,
    queryKey: ["resetTokenValidity", token],
    queryFn: () => checkResetTokenValidity(token),
  });
};
